import get from 'lodash/get';
import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {useGetCasesQuery} from '../../redux/services/caseApi';

import AppDashboard from '../AppDashboard';
import ListCasesScreen from "../../components/cases/ListCasesScreen";

const parseSearchParams = searchParams => {
  const allowedFields = [
    'status',
    'billing_category',
    'inactive',
    'patient_id',
  ];
  const filters = allowedFields.reduce((acc, k) => {
    const val = searchParams.get(k);
    // include_nonowned_sessions should only be set if patient_id is also set
    if (val) {
      if (val === 'true') return {...acc, [k]: true};
      if (val === 'false') return {...acc, [k]: false};
      return {...acc, [k]: val};
    }
    return acc;
  }, {sort: '-date_created'});
  return filters;
};

const tabs = [
  'all',
  'active',
  'inactive',
];

const handleFilter = ({setFilters, setSearchParams}) => filter => {
  setSearchParams(filter || {});
  setFilters(filter || {});
};

const handleTabChange = ({setTab, setPageIndex}) => tab => {
  setTab(tab);
  setPageIndex(0);
};

const ListCasesPage = props => {
  // https://stackoverflow.com/questions/75522048/react-how-to-access-urls-parameters
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(parseSearchParams(searchParams));
  const [pageIndex, setPageIndex] = useState(
    tabs.reduce((acc, next) => ({...acc, [next]: 0}), {}) // set pageIndex to 0
  );
  const [pageSize, setPageSize] = useState(25);
  const [tab, setTab] = useState(tabs[0]);
  const providerQuery = useGetCurrentProviderQuery();
  const onTabChange = handleTabChange({setTab, setPageIndex});
  const queries = {
    all: useGetCasesQuery(
      {skip: pageIndex.all * pageSize || 0, limit: pageSize, ...filters}, 
      {skip: false}
    ),
    active: useGetCasesQuery(
      {skip: pageIndex.active * pageSize || 0, limit: pageSize, ...filters, status: 'ACTIVE'}, 
      {skip: false}
    ),
    inactive: useGetCasesQuery(
      {skip: pageIndex.inactive * pageSize || 0, limit: pageSize, ...filters, inactive: 'true'},
      {skip: false}
    ),
  };
  const childProps = {
    ...props,
    // data
    cases: tabs.reduce((acc, t) => ({
      ...acc,
      [t]: get(queries, `${t}.data.data`) || [],
    }), {}),
    counts: tabs.reduce((acc, t) => ({
      ...acc,
      [t]: get(queries, `${t}.data.count`) || 0,
    }), {}),
    queries,
    isLoading: providerQuery.isLoading || queries?.[tab]?.isLoading,
    isUpdating: (
      providerQuery.isLoading
      || queries?.[tab]?.isFetching 
      || queries?.[tab]?.isLoading
    ),
    // tabs
    tab,
    tabs,
    onTabChange,
    // pagination
    pageIndex,
    pageSize,
    filters,
    // handlers
    onFilterChange: handleFilter({setFilters, setSearchParams}),
    onPageChange: category => (e,num) => setPageIndex({...pageIndex, [category]: num}),
    onRowsPerPageChange: e => setPageSize(parseInt(e.target.value, 10)),
  };
  return (
    <AppDashboard title='Cases' loading={childProps.isLoading} showTitle showHomeBtn>
      <ListCasesScreen {...childProps} />
    </AppDashboard>
  );
};

export default ListCasesPage;
